import { render } from "./DynamicAppTable.vue?vue&type=template&id=86a51302&scoped=true"
import script from "./DynamicAppTable.vue?vue&type=script&lang=js"
export * from "./DynamicAppTable.vue?vue&type=script&lang=js"

import "./DynamicAppTable.vue?vue&type=style&index=0&id=86a51302&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a51302"]])

export default __exports__